import createTheme from '@mui/material/styles/createTheme';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#09D334',
      light: '#00FF54',
      contrastText: 'white',
    },
    secondary: {
      main: '#669600',
      contrastText: 'white',
    },
  },
  typography: {
    allVariants: {
      color: 'white',
      fontFamily: 'Segoe UI',
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'white',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: 'white',
          '&:hover': {
            borderColor: '#09D334',
          },
          '&:hover & $notchedOutline': {
            borderColor: '#09D334',
          },
          '& fieldset': {
            borderColor: '#09D334',
          },
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 'normal',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
  },
});

export default theme;
